import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { t } from 'i18next';

import { useQueryParams } from '@pocapan/shared/utils/useQueryParams';
import { getLocationEventEmoji } from '@pocapan/shared/utils/EventUtils';

import StickyHeader from '../../../components/StickyHeader';
import { ReportFootprintBreadcrumb } from '../../../components/report/ReportFootprintBreadcrumb';
import StepComponent from '../../../components/steps/StepComponent';

import { ArrowRight, ArrowRightSmall } from '@peacecover/icon';
import { spots } from '../../../constants/spots';

export default function ReportFootprintsSpotsPage() {
  const navigate = useNavigate();
  const { removeQueryParams } = useQueryParams();

  return (
    <>
      <Helmet>
        <title>{t('ReportFootprintsSpotsPage.pageTitle', { defaultValue: '제보하기' })}</title>
      </Helmet>
      <StickyHeader
        title={t('ReportFootprintsSpotsPage.pageTitle', { defaultValue: '제보하기' }) as string}
        alwaysShowTitle={true}
        showBackButton={true}
        showTitle={true}
        onClickBackButton={() => removeQueryParams(['memberId'], '/report/select-member')}
      />
      <div className="flex flex-col pt-[calc(54px+env(safe-area-inset-top))] pb-[calc(128px+env(safe-area-inset-bottom))]">
        <div className="px-[24px]">
          <StepComponent currentStep={0} nextStep={1} maxStep={1} title="">
            <div className="flex flex-col gap-[18px] py-[10px] mb-[16px]">
              <div className="mx-[-24px]">
                <ReportFootprintBreadcrumb />
              </div>
              <div className="text-[26px] font-bold whitespace-pre-wrap text-text-main-lv1">
                {t('ReportFootprintsSpotsPage.title', { defaultValue: '어떤 장소인가요?' })}
              </div>
            </div>
            <div className="flex flex-col gap-[10px]">
              {spots.map((spot) => (
                <SpotsCategoryBox key={spot.key} spot={spot} />
              ))}
            </div>
            <button
              type="button"
              className="flex items-center mt-[32px] mx-auto"
              onClick={() => navigate('/collections?boxTabIndex=1', { replace: true })}
            >
              <p className="text-[14px] font-medium text-text-main-lv4 leading-none">
                {t('ReportFootprintsSpotsPage.noMatch', { defaultValue: '해당되는 유형이 없어요' })}
              </p>
              <ArrowRightSmall size={20} className="text-text-main-lv4" />
            </button>
          </StepComponent>
        </div>
      </div>
    </>
  );
}

const SpotsCategoryBox = ({ spot }: { spot: { key: string } }) => {
  const { updateQueryParams } = useQueryParams();

  const handleSelect = (category: string) => {
    updateQueryParams({ spotsCategory: category }, '/report-location/search-location');
  };

  return (
    <button
      type="button"
      onClick={() => handleSelect(spot.key)}
      className="bg-background-light dark:bg-background-dark dark:border dark:border-[#141414] rounded-[12px] p-[20px] cursor-pointer flex justify-between items-center w-full text-left shadow-[0_0_14px_rgba(0,0,0,0.08),0_0_0_1px_rgba(0,0,0,0.01)] dark:shadow-[0_0_0_1px_rgba(255,255,255,0.08),0_0_14px_0_rgba(255,255,255,0.01)]"
    >
      <div className="flex flex-col text-left gap-[8px]">
        <div className="flex items-center gap-[4px] text-[17px] font-semibold leading-none text-text-main-lv1">
          <img src={getLocationEventEmoji(spot.key)} alt={spot.key} className="w-[17px] h-[17px]" />
          {t(`SpotsCategory.${spot.key}.value`)}
        </div>
        <div className="text-[13px] text-text-main-lv4">
          {t(`SpotsCategory.${spot.key}.description`)}
        </div>
      </div>
      <ArrowRight size={20} className="text-text-main-lv4" />
    </button>
  );
};
